/**
 * Transfers KPIs Component
 *
 * Displays KPIs cards for transfers.
 * @see Sprint 14 - Transferts Inter-Sites
 * @see US-14.5 - UI Liste et Creation
 */

import { Package, Send, Inbox, AlertTriangle, TrendingUp } from 'lucide-react';
import { KPICard, Skeleton } from '@/components/ui';
import { useTransfersKPIs } from '../hooks';
import { useCurrency } from '@/hooks';
import { formatCentimes } from '@/lib/format';

export function TransfersKPIs() {
  const { data: kpis, isLoading } = useTransfersKPIs();
  const currency = useCurrency();

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <Skeleton key={i} className="h-24" />
        ))}
      </div>
    );
  }

  if (!kpis) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
      <KPICard
        title="Mes demandes en attente"
        value={kpis.myPendingRequests}
        icon={<Package className="w-4 h-4" />}
      />
      <KPICard
        title="A traiter"
        value={kpis.toProcessRequests}
        icon={<Send className="w-4 h-4" />}
        badge={kpis.toProcessRequests > 0 ? { label: 'Action requise', variant: 'info' } : undefined}
      />
      <KPICard
        title="En transit vers moi"
        value={kpis.inTransitToMe}
        icon={<Inbox className="w-4 h-4" />}
        badge={kpis.inTransitToMe > 0 ? { label: 'En cours', variant: 'success' } : undefined}
      />
      <KPICard
        title="En transit depuis moi"
        value={kpis.inTransitFromMe}
        icon={<Send className="w-4 h-4" />}
      />
      <KPICard
        title="En litige"
        value={kpis.disputed}
        icon={<AlertTriangle className="w-4 h-4" />}
        badge={kpis.disputed > 0 ? { label: 'Attention', variant: 'danger' } : undefined}
      />
      <KPICard
        title="Ce mois"
        value={formatCentimes(kpis.monthlyValueCentimes, currency)}
        subtitle={`${kpis.monthlyCount} transferts`}
        icon={<TrendingUp className="w-4 h-4" />}
      />
    </div>
  );
}
